/* eslint-disable parog-web/no-glint-expect-error-directive */
import Component from '@glimmer/component';
import type { Signature as ForcProviderSignature } from 'parog-web/components/forc/provider';

interface Signature {
  Args: {
    form?: ForcProviderSignature['Blocks']['content'][0];
  };
}

export default class FileUploadedEditionFormContentComponent extends Component<Signature> {
  static titleMaximumChars = 30;

  <template>
    <div class='field'>
      <@form.Date
        @labelName='Date du document'
        @propertyName='occurredAt'
        @isMandatory={{true}}
        data-test-occurred-at
      />
    </div>
    <div class='field'>
      <@form.Dropdown
        @propertyName='fileSubType'
        @labelName='Type du fichier'
        @placeholder='Veuillez sélectionner le type du fichier.'
        @isMandatory={{true}}
        @allowAdditions={{true}}
        as |dropdown|
      >
        <dropdown.Item
          @key='pre-transplant-folder'
          @value='Dossier pré-greffe'
        />
        <dropdown.Item @key='other' @value='Autre' />
      </@form.Dropdown>
    </div>
    <div class='field'>
      <@form.Input
        @labelName='Titre'
        {{! @glint-expect-error }}
        @max={{this.titleMaximumChars}}
        @placeholder='Veuillez indiquer un titre pour votre document. Maximum 30 caractères.'
        @propertyName='title'
        @isMandatory={{true}}
      />
    </div>
    <div class='field'>
      <@form.TextArea
        @labelName='Commentaire'
        @propertyName='body'
        @rows={{4}}
      />
    </div>
  </template>
}
